module.exports = __webpack_public_path__ + "static/media/turkish.ac7cd218.png";